import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { Typography } from "@circle-react-uikit/Typography";

interface Student {
  avatar_url: string;
  name: string;
  public_uid: string;
}

interface ProfileButtonProps {
  student: Student;
}

export const ProfileButton = ({ student }: ProfileButtonProps) => {
  const profileLinkProps = useProfileLinkProps({
    public_uid: student.public_uid,
  });

  return (
    <a {...profileLinkProps} className="flex w-full items-center gap-3">
      <UserImage src={student.avatar_url} name={student.name} size="6" />
      <Typography.BodySm weight="medium truncate">
        {student.name}
      </Typography.BodySm>
    </a>
  );
};
